import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { Leaf, Loader2 } from "lucide-react";
import { useAuth } from "@/context/AuthContext";
import { toast } from "sonner";

export default function Login() {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [loading, setLoading] = useState(false);
  const { login } = useAuth();
  const nav = useNavigate();

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      await login(email, password);
      toast.success("Connexion réussie");
      nav("/admin");
    } catch (err) {
      const d = err.response?.data?.detail;
      toast.error(typeof d === "string" ? d : "Identifiants incorrects");
    } finally {
      setLoading(false);
    }
  };

  const quickLogin = async (em, pw) => {
    setEmail(em); setPassword(pw); setLoading(true);
    try { await login(em, pw); toast.success("Connexion réussie"); nav("/admin"); }
    catch { toast.error("Échec de connexion rapide"); }
    finally { setLoading(false); }
  };

  return (
    <div className="min-h-screen flex items-center justify-center bg-forest p-6">
      <div className="w-full max-w-md">
        <div className="text-center mb-8">
          <div className="mx-auto h-14 w-14 rounded-2xl bg-brand flex items-center justify-center mb-4"><Leaf className="text-cream" size={28} /></div>
          <h1 className="font-display text-4xl text-cream">Acanthe Jardins</h1>
          <p className="text-cream/50 text-sm mt-1">Espace professionnel</p>
        </div>
        <form onSubmit={submit} className="rounded-2xl bg-cream p-8 space-y-4" data-testid="login-form">
          <div>
            <label className="text-sm font-medium text-forest">Email</label>
            <input type="email" required value={email} onChange={(e) => setEmail(e.target.value)} data-testid="login-email"
              className="mt-1.5 w-full rounded-xl border border-border px-4 py-3 text-sm focus:outline-none focus:ring-2 focus:ring-brand/30" placeholder="admin@acanthejardins.fr" />
          </div>
          <div>
            <label className="text-sm font-medium text-forest">Mot de passe</label>
            <input type="password" required value={password} onChange={(e) => setPassword(e.target.value)} data-testid="login-password"
              className="mt-1.5 w-full rounded-xl border border-border px-4 py-3 text-sm focus:outline-none focus:ring-2 focus:ring-brand/30" placeholder="••••••••" />
          </div>
          <button type="submit" disabled={loading} data-testid="login-submit"
            className="w-full rounded-xl bg-brand text-cream font-semibold py-3 hover:bg-forest transition-colors flex items-center justify-center gap-2 disabled:opacity-60">
            {loading && <Loader2 className="animate-spin" size={18} />} Se connecter
          </button>

          <div className="pt-4 border-t border-border">
            <p className="text-[11px] uppercase tracking-wider text-stone/60 text-center mb-2">Connexion rapide (test)</p>
            <div className="grid grid-cols-2 gap-2">
              <button type="button" onClick={() => quickLogin("admin@acanthejardins.fr", "Acanthe2026!")} disabled={loading} data-testid="quick-admin"
                className="rounded-lg bg-forest/10 text-forest text-xs font-semibold py-2.5 hover:bg-forest hover:text-cream transition-colors disabled:opacity-60">👑 Admin</button>
              <button type="button" onClick={() => quickLogin("service@acanthejardins.fr", "Service2026!")} disabled={loading} data-testid="quick-service"
                className="rounded-lg bg-brand/10 text-brand text-xs font-semibold py-2.5 hover:bg-brand hover:text-cream transition-colors disabled:opacity-60">🎧 Service client</button>
            </div>
          </div>
        </form>
      </div>
    </div>
  );
}
